/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountDefaultCountryQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountDefaultCountryQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly defaultCountry: string, readonly id: CK.AccountId } | null };


export const AccountDefaultCountryDocument = gql`
    query AccountDefaultCountry($accountId: AccountId!) {
  account(id: $accountId) {
    defaultCountry
    id
  }
}
    `;

/**
 * __useAccountDefaultCountryQuery__
 *
 * To run a query within a React component, call `useAccountDefaultCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountDefaultCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountDefaultCountryQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountDefaultCountryQuery(baseOptions: Apollo.QueryHookOptions<AccountDefaultCountryQuery, AccountDefaultCountryQueryVariables> & ({ variables: AccountDefaultCountryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountDefaultCountryQuery, AccountDefaultCountryQueryVariables>(AccountDefaultCountryDocument, options);
      }
export function useAccountDefaultCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountDefaultCountryQuery, AccountDefaultCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountDefaultCountryQuery, AccountDefaultCountryQueryVariables>(AccountDefaultCountryDocument, options);
        }
export function useAccountDefaultCountrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountDefaultCountryQuery, AccountDefaultCountryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountDefaultCountryQuery, AccountDefaultCountryQueryVariables>(AccountDefaultCountryDocument, options);
        }
export type AccountDefaultCountryQueryHookResult = ReturnType<typeof useAccountDefaultCountryQuery>;
export type AccountDefaultCountryLazyQueryHookResult = ReturnType<typeof useAccountDefaultCountryLazyQuery>;
export type AccountDefaultCountrySuspenseQueryHookResult = ReturnType<typeof useAccountDefaultCountrySuspenseQuery>;
export type AccountDefaultCountryQueryResult = Apollo.QueryResult<AccountDefaultCountryQuery, AccountDefaultCountryQueryVariables>;